import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SessionAuthProvider } from "@/auth/SessionAuth";

ReactDOM.render(
  <React.StrictMode>
    <SessionAuthProvider>
      <App />
    </SessionAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
